// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';

import baseTheme from '../../trellis/light/theme';

export type ThemeName = 'lavender';

export type ThemeMode = 'light';

/**
 * Design System theme object.
 *
 * Theme name: `lavender`
 *
 * Theme mode: `light`
 */
const theme = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    'fwc-button-border-primary-default': '#c93700',
    'fwc-button-border-primary-hover': '#c93700',
    'fwc-button-border-primary-pressed': '#c93700',
    'fwc-button-fill-primary-default': '#e74100',
    'fwc-button-fill-primary-disabled': '#f0f0f0',
    'fwc-button-fill-primary-hover': '#c93700',
    'fwc-button-fill-primary-pressed': '#9f2800',
    'fwc-button-text-primary-disabled': '#b3b3b3',
  },
};

Object.assign(theme, {
  [THEME_NAME]: 'lavender',
  [THEME_MODE]: 'light',
});

export default theme;
